import React from 'react';
import './page404.scss';

class Page404 extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <section className='section404'>
        <div className='wprap404'>
          <h2>404 ;(</h2>
        </div>
      </section>
    );
  };
};

export default  Page404;



// WEBPACK FOOTER //
// ./src/client/components/page404/page404.jsx